export default __webpack_public_path__ + "static/media/Roboto-BoldItalic.ed4469d8.ttf";